import { orgBilling, orgBillingCount } from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

export default async function orgBillingData(
    limit,
    offset,
    orgId,
    status,
    approval,
    setBillingData,
    setLoading,
    serviceType
) {
    setLoading(true);
    try {
        const billingData = await orgBilling(orgId, status, approval, limit, offset, serviceType);
        setBillingData(billingData.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}

export const billingCount = (orgId, setTotalCount, status, selectedApproval, setLoading, serviceType) => {
    setLoading(true);
    try {
        orgBillingCount(orgId, status, selectedApproval, serviceType).then((res) => {
            setTotalCount(res.data.billsCount);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
